module.exports = __webpack_public_path__ + "static/img_placeholder.d8d17112.svg";